import type { FaireProductEntity } from "../../entity_types/product";

export const p_9flnk96wdf: FaireProductEntity = {
  token: "p_9flnk96wdf",
  type: "product",
  name: "Organic Germ Fighter Essential Oil 10 mL",
  brandToken: "b_3z46kjdoak",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/6bcf428c1cb3a2406c7a410482a44d2a5b37b0f1c3f1572a32c7aa4d5d84cdb6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bfea09201663d56614d447db79b6a8c940bc71606da14901a914dc959b02a412.jpeg",
    "https://cdn.faire.com/fastly/4b6cb9185bd551cdffdcfdbd800ab121f79dace2653602f78c90512b8d8a0400.webp",
    "https://cdn.faire.com/fastly/8cb3c40e90b27a9ba310d99d6461ad0709693cb59e45b251f3989274efc8f20f.jpeg",
    "https://cdn.faire.com/fastly/9b2af970b8b6866279d4244315e4c3f71670071785cf82e6a6aef7d293a72a6a.webp",
    "https://cdn.faire.com/fastly/c800f90db05b87f15014631401ecfb322a9424e705d6e87fe134f21fb4dff961.jpeg",
    "https://cdn.faire.com/fastly/651ab9b949f6ae60826ef0bc54078e66c560ad7fa39af404968e098ad07b1ad1.jpeg",
    "https://cdn.faire.com/fastly/bf652ee585b4ab9fabb5e3f6f97c8b031cc57bdb3080fa5bf5f8c5fad4534c67.jpeg",
  ],
  priceDollars: 9.7,
  description:
    "It is so important to keep your body on alert against attacks on your immune system. Organic Germ Fighter was made with you in mind because when you are down you need something to help you recover fast. Organic Germ Fighter is jam-packed with everything you need to fight off outside threats. Organic Germ Fighter is a Plant Therapy favorite and for good reason; it does its job and will continue to support a healthy immune system by helping your body get back to its natural state from the seasonal threats that have you down. Whether it’s keeping your hands clean, or warding off seasonal threats going around the office or school by keeping your body on high alert, Organic Germ Fighter will give you that extra protection you need. The next time an attack on your immune system happens reach for Organic Germ Fighter to turn around to a healthy state faster!\n\nThis blend is made with only USDA Certified Organic essential oils. That means that this blend is free from GMOs.",
  tags: [],
  msrpDollars: 19.39,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:04.718Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
